module.exports = function (str) {
  var parsed;
  if (typeof JSON === 'object') {
    parsed = JSON.parse(str);
  } else {
    parsed = eval('(' + str + ')');
  }
  return parsed;
};



//////////////////
// WEBPACK FOOTER
// /~/jwt-decode/lib/json_parse.js
// module id = 1311
// module chunks = 0